import { Modal } from 'antd'
import Checkbox from 'components/Checkbox'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import info from './assets/info.svg'
import { ImportantMailInformation, ImportantMailWrapper } from './styles'

interface IProps {
  text: string
}

const ImportantMail = (props: IProps) => {
  const { t } = useTranslation()
  const [modalIsOpen, setModalIsOpen] = useState(false)

  return (
    <ImportantMailWrapper>
      <ImportantMailInformation onClick={()=>setModalIsOpen(!modalIsOpen)}>
        <img src={info} alt="description" />
        <span>{t('mails.important-mail.title')}</span>
        {
          modalIsOpen &&
          <Modal
            className='important-mail-modal'
            visible={modalIsOpen}
            closable={false}
            maskClosable={true}
            footer={null}
            mask={false}
          >
            {props.text}
          </Modal>
        }

      </ImportantMailInformation>

      <Checkbox
        name="importantMail"
        label={t('mails.important-mail.mark')}
      />
    </ImportantMailWrapper>
  )
}

export default ImportantMail
